// extracted by mini-css-extract-plugin
export default {"divider":"principalInfo_divider__bYcf+"};